export const ENGLISH_TRANSLATIONS = {
  language: "en",
};
